import { useCallback } from "react";
import { useMutation, queryCache } from "react-query";
import { saveMeterReading } from "../services/meterpoints/readings";

export const useMeterReadingMutation = (accountNumber: string) => {
  const [mutate, { status, error }] = useMutation(saveMeterReading, {
    onSuccess: async () => {
      await Promise.all([
        queryCache.invalidateQueries(["accounts/tickets", accountNumber]),
        queryCache.invalidateQueries(["accounts/activities", accountNumber]),
      ]);
    },
  });

  const saveReading = useCallback(
    async (values: Record<string, any>, ignoreWarnings: boolean = false) => {
      return await mutate({
        accountNumber,
        values,
        ignoreWarnings,
      });
    },
    [accountNumber, mutate],
  );

  return {
    saveReading,
    status,
    error,
  };
};
